export const institutionConstants = {
  GET_INSTITUTIONS: "GET_INSTITUTIONS",
  GET_INSTITUTION: "GET_INSTITUTION",
};
